import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import logo from "../../images/logo.png";

const Footer = () => {
  return (
<footer className="footer-custom">
  <div className="footer-content">
    <img
      src={logo}
      width="60"
      height="60"
      alt="Inertia7 Logo"
      className="footer-logo"
    />
    <h5 className="footer-title">Inertia7</h5>
    <p className="footer-tagline">
      A platform for documenting your technical projects.
    </p>
    <p className="footer-credit">
      Built with{" "}
      <FontAwesomeIcon icon={faHeart} className="footer-heart" aria-label="love" />{" "}
      in New York City.
    </p>
    <br/><br/>
    <nav className="footer-links">
      <Link to="/about">About</Link>
      <Link to="/terms">Terms of Use</Link>
      <Link to="/privacy">Privacy Policy</Link>
      <Link to="/contact">Contact</Link>
    </nav>
    <br/>
    <p className="footer-copy">
      © {new Date().getFullYear()} Inertia7. All rights reserved.
    </p>
  </div>
</footer>

  );
};

export default Footer;
